<template>
  <el-dialog
    title="信息异常"
    :visible.sync="show"
    width="500px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    >
    <el-form label-position="left" label-width="100px">
      <div class="pure-g">
        <div class="pure-u-1-1">
          <el-form-item class="form_item" label="姓名：">{{ info.name }}</el-form-item>
          <el-form-item class="form_item" label="手机号：">{{ info.mobile }}</el-form-item>
          <el-form-item class="form_item" label="证件号码：">{{ info.idNo||'无' }}</el-form-item>
          <el-form-item>客户在blc名单中，拨打如下电话了解详情</el-form-item>
          <el-form-item class="form_item" label="咨询人员：" v-for="(item,index) in managerMemberList" :key="index">{{ item }}</el-form-item>
        </div>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="text" @click="handleClose">确定</el-button>
    </span>
</el-dialog>
</template>
<script>
export default {
  name: 'BlcTips',
  props: {
    visible: {
      type:Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => ({})
    }
  },
  computed:{
    show() {
      return this.visible
    },
    managerMemberList() {
      return this.info.detail?.split(',') ?? []
    },
  },
  data () {
    return {
      
    }
  },
  methods: {
    handleClose() {
      // this.show = false;
      this.$emit("update:visible", false)
      this.$emit("close")
    }
  }
}
</script>
<style scoped>
.el-form-item{
  margin-bottom: 0;
}
</style>